import {
  BrowserCacheLocation,
  EventType,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';

import { env } from '#lib/env';

const { cluster, clientId, tenantId, redirectUri } = env.auth;
const baseUrl = `https://${cluster}.cognitedata.com`;
const scopes: string[] = [`${baseUrl}/.default`];
const request = { scopes };

const pca = new PublicClientApplication({
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.SessionStorage,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        return;
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
});

export function AuthProvider({ children }: React.PropsWithChildren) {
  pca.addEventCallback((event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS &&
      event?.payload &&
      'account' in event.payload &&
      event.payload?.account
    ) {
      const account = event.payload?.account;
      console.debug('Login successful, setting active account:', account);
      pca.setActiveAccount(account);
    }
  });

  return (
    <MsalProvider instance={pca}>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={request}>
        {children}
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
}
